import React from 'react'
import Reels from '../../componetns/reels'
import MobileHeader from './mobileHeader'
const ReelsMobile = () => {
    return (
        <div>
            <div className='mobile_reels'>
                <MobileHeader />
                <div className="p-3 mobile_reels">
                    <Reels />
                </div>

            </div>
        </div>
    )
}

export default ReelsMobile